import { useState, React } from 'react';
import config from '../../config/config';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import './css/footer.css';
import { submitContactDetailsAction } from '../../apis/apiAction';
import { Toaster, toast } from 'react-hot-toast';

const Footer = () => {
  const handleClose = () => {
    setFormData({ email: '' });
  };
  const [formData, setFormData] = useState({
    email: '',
  });

  const inputHandler = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const isValidate = () => {
    if (!formData.email) {
      toast.error('Email is required');
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error('Enter a valid email');
      return false;
    }
    return true;
  };

  const submitContactDetails = async () => {
    if (!isValidate()) return;
    try {
      let res = await submitContactDetailsAction(formData);
      if (res.status) {
        toast.success('You are Subscribed!!');
        handleClose();
      } else {
        toast.error(res.message);
        handleClose();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  return (
    <>
      <Toaster />
      <footer className="position-relative">
        <Container>
          <Row className=" mb-0">
            <Col xl={3} lg={12} className="mb-5">
              <div className="footer-logo">
                
                <img
                  src="assets/images/logo/logo.png"
                  className="w-85"
                  alt=""
                />
              </div>
            </Col>
            <Col xl={6} lg={6} className="mb-4">
              <div className="ps-lg-4">
                <Row>
                  <Col lg={6} md={6} xs={6} className="mb-4">
                    <div className="footer-widget">
                      <h6 className="text-primary">General</h6>
                      <ul className="mb-0 list-unstyled">
                        <li className="">
                          <a
                            href={`${config.baseUrl}privacypolicy`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Privacy Policy
                          </a>
                        </li>
                        <li className="">
                          <a
                            href={`${config.baseUrl}termsofuse`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Terms of use
                          </a>
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col lg={6} md={6} xs={6} className="mb-4">
                    <div className="footer-widget">
                      <h6 className="text-primary">Get Connected</h6>
                      <ul className="mb-0 list-unstyled">
                        <li className=" me-3">
                          <a href={`${config.baseUrl}blog`}>Blog</a>
                        </li>
                        <li>
                          <a href={`${config.baseUrl}pressrelease`}> News</a>
                        </li>
                      </ul>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xl={3} lg={6} className="mb-4 px-lg-0">
              <div className="footer-block ">
                <div className="mb-5 text-lg-end">
                  <div className="mb-4">Follow us on social media</div>
                  <div className="social-icon mb-2">
                    <a
                      target="_blank"
                      href="https://x.com/unitronix_corp"
                      rel="noreferrer"
                      className=""
                    >
                      <img src="assets/images/icon/twitter.svg" alt="" />
                    </a>
                    <a
                      target="_blank"
                      href="https://medium.com/@unitronixcorp"
                      className=""
                      rel="noreferrer"
                    >
                      <img src="assets/images/icon/medium.svg" alt="" />
                    </a>
                    <a
                      target="_blank"
                      href="https://www.youtube.com/@UnitronixCorp"
                      rel="noreferrer"
                    >
                      <img src="assets/images/icon/youtube.svg" alt="" />
                    </a>
                    <a
                      target="_blank"
                      href="https://discord.gg/unitronix"
                      rel="noreferrer"
                    >
                      <img src="assets/images/icon/discord.svg" alt="" />
                    </a>
                  </div>
                </div>
                <div className=" ">
                  <div>
                    <small>Sign up for email updates to keep up to date</small>
                    <Form className="mt-3 getUpdate">
                      <div className="d-flex">
                        <div className="w-100 me-3">
                          <Form.Control
                            type="email"
                            value={formData.email}
                            placeholder="Email"
                            onChange={inputHandler}
                            name="email"
                            className="bg-white text-black box-shadow-none w-100"
                          />
                        </div>
                        <div className="">
                          <Button
                            className="text-black  text-nowrap"
                            variant="primary"
                            onClick={submitContactDetails}
                          >
                            GET UPDATES!
                          </Button>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="align-items-center mb-3">
            <Col lg={4} md={6} className="">
              <div className=" d-flex align-items-center">
                <div className="border-right pr-1">
                  <a href="#" className="text-white text-decoration-none">
                    © 2025 Unitronix Corporation. All rights reserved.
                  </a>
                </div>
              </div>
            </Col>
            <Col lg={4} md={4} className=""></Col>
          </Row>
        </Container>
        <div className="copyright">
          <Container>
            <Row className="justify-content-center">
              <hr />
              {/* <Col lg={12} className="text-center">
                <a href="mailto:support@unitronix.com" className="text-white">
                  <p>support@unitronix.com</p>
                </a>
              </Col> */}
            </Row>
          </Container>
        </div>
        <div
          className="bgleft position-absolute bottom-0 start-0 end-0"
          style={{ zIndex: '-1' }}
        >
          <img src="assets/images/shape/bgbottom.svg" className="w-100" />
        </div>
      </footer>
    </>
  );
};
export default Footer;
